<!-- <p>forget-password-dialog works!</p> -->
<div
  [ngClass]="{
    'forget-password-dialog-container':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'forget-password-dialog-container-mobile': screenSize == ScreenType.Mobile
  }"
>
  <div class="forget-password-dialog-header">
    <b>Forget Password </b>
    <button mat-mini-fab mat-dialog-close>
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div *ngIf="isFetching || isChecking" class="loading-spinner">
    <mat-spinner></mat-spinner>
  </div>
  <div *ngIf="isChecking && !isMobileExists" class="centered-text">
    <b><i>Submitted your request</i></b
    ><br />
    <b>Checking if this mobile number exists!</b>
  </div>
  <div *ngIf="isChecking && isMobileExists" class="centered-text">
    <b><i>Updating Credentials</i></b
    ><br />
    <b>Please Wait!</b>
  </div>
  <div *ngIf="isRequested">
    <div
      style="
        width: 100%;
        height: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        letter-spacing: 2px;
        text-align: center;
      "
    >
      <b>Please check you E-mail and Mobile!</b>
    </div>
    <br />
    <div class="forget-password-dialog-action">
      <button mat-raised-button mat-dialog-close>Close</button>
    </div>
  </div>
  <div
    class="centered-text"
    style="color: red; letter-spacing: 2px; font-size: 24px"
    *ngIf="isChecked && !isMobileExists && !isChecking"
  >
    <strong> *Account Not Found!, Please Retry</strong>
    <div class="forget-password-dialog-action">
      <button mat-raised-button mat-dialog-close>Cancel</button>
      <button
        mat-raised-button
        (click)="isFetching = !isFetching && (isChecked = !isChecked)"
      >
        Re-Try
      </button>
    </div>
  </div>
  <div
    style="margin-top: 15px"
    *ngIf="isChecked && isMobileExists && !isChecking && !isRequested"
  >
    <div
      class="centered-text"
      style="color: green; letter-spacing: 2px; font-size: 24px"
    >
      <strong> *Mobile Found!, Select Org!</strong>
    </div>
    <br />
    <br />
    <div class="forget-password-dialog-action" *ngIf="false">
      <b><i>Not Yours?</i></b>
      <button
        mat-raised-button
        (click)="isFetching = !isFetching && (isChecked = !isChecked)"
      >
        Re-Try
      </button>
    </div>
    <div style="display: flex; justify-content: center">
      <form [formGroup]="forgetPasswordForm">
        <mat-form-field
          subscriptSizing="dynamic"
          appearance="outline"
          hideRequiredMarker
        >
          <mat-label>Organization Details</mat-label>
          <mat-select formControlName="orgId">
            <mat-option
              *ngFor="let org of organizations"
              [value]="org.organizationID"
            >
              {{ org.organizationName | titlecase }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </form>
    </div>
    <br />
    <br />
    <div class="forget-password-dialog-action">
      <button
        mat-raised-button
        [disabled]="!forgetPasswordForm.controls.orgId.value"
        (click)="onRequestNewCreds()"
      >
        Request Creds
      </button>
    </div>
  </div>
  <div *ngIf="!isFetching && !isChecked">
    <form [formGroup]="forgetPasswordForm">
      <mat-grid-list rowHeight="85px" cols="1">
        <mat-grid-tile *ngIf="isMobileExists"
          ><mat-form-field
            subscriptSizing="dynamic"
            appearance="outline"
            hideRequiredMarker
          >
            <mat-label>Organization Details</mat-label>
            <mat-select formControlName="orgId">
              <mat-option
                *ngFor="let org of organizations"
                [value]="org.organizationID"
              >
                {{ org.organizationName | titlecase }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>
        <!-- <mat-grid-tile>
          <mat-form-field
            subscriptSizing="dynamic"
            appearance="outline"
            hideRequiredMarker
          >
            <mat-label>Email Address</mat-label>
            <input formControlName="email" matInput /> </mat-form-field
        ></mat-grid-tile> -->
        <mat-grid-tile>
          <!-- <mat-form-field
            subscriptSizing="dynamic"
            appearance="outline"
            hideRequiredMarker
          >
            <mat-label>Phone Number</mat-label>
            <input formControlName="userPhone" matInput /> </mat-form-field
        > -->
          <mat-form-field
            subscriptSizing="dynamic"
            appearance="outline"
            hideRequiredMarker
          >
            <ngx-mat-intl-tel-input
              #phoneInput
              [enablePlaceholder]="true"
              [required]="true"
              [preferredCountries]="['in']"
              [enableSearch]="true"
              name="phone"
              formControlName="mobileNumber"
              [inputPlaceholder]="'Phone Number *'"
              [label]="'Mobile Number'"
              [maxlength]="15"
            ></ngx-mat-intl-tel-input>
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </form>
    <!-- <div class="centered-text">
      <b><i>Your login credential</i></b
      ><br />
      <b><i>will be emailed if account found.</i></b>
    </div> -->

    <div class="forget-password-dialog-action">
      <!-- <button mat-raised-button mat-dialog-close>Cancel</button> -->
      <button
        (click)="onCheckMobileNumberExists()"
        mat-raised-button
        [disabled]="forgetPasswordForm.invalid"
      >
        Submit
      </button>
    </div>
  </div>
</div>
